import React from "react";
import Pages from "../pages";
import PrivateRoute from "./PrivateRoute";
import AdminGate from "./AdminGate";
import { Navigate, RouteObject, useRoutes } from "react-router-dom";
import { Cookies } from "react-cookie";

const cookies = new Cookies();
const getCookie = (item: string) => {
  return cookies.get(item);
};

export const Root: RouteObject = {
  path: "/*",
  element: (
    <Navigate
      replace
      to={getCookie("menu") ? getCookie("menu") : "/templates"}
    />
  ),
};

export const Templated: RouteObject = {
  path: "templates",
  element: <Pages.Templates />,
};

export const TemplatedhasUserName: RouteObject = {
  path: "templates/userid/:name",
  element: <Pages.Templates />,
};

export const TemplatedDetails: RouteObject = {
  path: "templates/:templateId",
  element: <Pages.TemplatesDetail />,
};

export const Moderation: RouteObject = {
  path: "moderation",
  element: <Pages.ModerationList />,
};

export const History: RouteObject = {
  path: "history",
  element: <Pages.History />,
};

export const AIReview: RouteObject = {
  path: "aireview",
  element: (
    <AdminGate>
      <Pages.AIReview />
    </AdminGate>
  ),
};

export const AppRouter = () =>
  useRoutes([
    Root,
    Templated,
    TemplatedhasUserName,
    TemplatedDetails,
    Moderation,
    History,
    AIReview,
  ]);

export default AppRouter;
